import { render, staticRenderFns } from "./Historys.vue?vue&type=template&id=21959ec6"
import script from "./Historys.vue?vue&type=script&lang=js"
export * from "./Historys.vue?vue&type=script&lang=js"
import style0 from "./Historys.vue?vue&type=style&index=0&id=21959ec6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports